import { createStore } from 'vuex'
import axios from "axios";
import { baseURL } from '../base-url.js';

import employeeModule from "./modules/employee/index.js";
import sale from "./modules/sale";
import cost from "./modules/cost";
import cashRegister from './modules/cash-register';
import report from './modules/report';
import salon from './modules/salon';
import user from "./modules/user";
import transaction from "./modules/transaction";
import product from './modules/product'
import task from './modules/task'
import tenant from './modules/tenant'

export default createStore({
  state: {
    id: null,
    jwt: null,
    login: null,
    role: null,
    salonId: null,
    name: null,
    tokenExpiration: null
  },
  mutations: {
    setUser(state, payload) {
      state.id = payload.id;
      state.jwt = payload.jwt;
      state.login = payload.login;
      state.role = payload.role;
      state.studioId = payload.studioId;
      state.name = payload.name
      state.tokenExpiration = payload.tokenExpiration
    },
    logout(state) {
      state.id = null;
      state.jwt = null;
      state.login = null;
      state.role = null;
      state.salonId = null;
      state.name = null;
      state.tokenExpiration = null;
    }
  },
  actions: {
    async login(context, payload) {
      return context.dispatch('auth', {
        ...payload
      });
    },

    async auth(context, payload) {
      try {
        const response = await axios.post(baseURL + "/user/authenticate", payload)
        const responseData = response.data;

        // const expiresIn = +responseData.expiresIn * 1000;
        const expirationDate =  response.data.expiration

        localStorage.setItem('jwt', responseData.jwt);
        localStorage.setItem('tokenExpiration', expirationDate);
        localStorage.setItem('salonId', responseData.roles[0].scopeId);
        localStorage.setItem('userType', responseData.roles[0].domain);
        localStorage.setItem('userRole', responseData.roles[0].role);
        localStorage.setItem('userId', responseData.id);

        context.commit('setUser', {
          userId: responseData.id,
          jwt: responseData.jwt,
          login: responseData.login,
          role: responseData.roles[0].role,
          name: responseData.name,
          salonId: responseData.roles[0].scopeId,
          tokenExpiration: expirationDate
        });

        return response;
      } catch (error) {
        throw error.response || error;
      }
    },
    logout({ commit }) {
      localStorage.removeItem('jwt');
      localStorage.removeItem('tokenExpiration');
      localStorage.removeItem('salonId');
      localStorage.removeItem('userType');
      localStorage.removeItem('userId');
      commit('logout');
    }
  },
  modules: {
    employee: employeeModule,
    sale,
    cost,
    cashRegister,
    report,
    salon,
    user,
    transaction,
    product,
    task,
    tenant
  }
})
